import { Input } from 'antd'
import { useState } from 'react'
import { DataTestId } from 'src/constants/ui.constants'

const { Search } = Input

export type SearchBoxProps = {
    height?: string
    placeholder?: string
    style?: React.CSSProperties
    width?: string
    onChange?: (value: string) => void
    onPressEnter?: (value: string) => void
    className?: string
}

const SearchBox: React.FC<SearchBoxProps> = ({
    onChange,
    width,
    style,
    onPressEnter,
    ...restProps
}) => {
    const [currVal, setCurrVal] = useState('')
    const [prevVal, setPrevVal] = useState('')

    const handleChange = (e: { target: { value: string } }) => {
        setCurrVal(e.target.value)
        onChange?.(e.target.value)
    }

    const handleEnter = () => {
        if (prevVal !== currVal) {
            setPrevVal(currVal)
            onPressEnter?.(currVal)
        }
    }

    return (
        <Search
            value={currVal}
            allowClear
            {...restProps}
            onChange={handleChange}
            style={{ width: width, ...style }}
            data-testid={DataTestId.SearchBox}
            onPressEnter={handleEnter}
        />
    )
}

export default SearchBox
